export default function empty2null(obj) {
  let temp = {};

  for (const property in obj) {
    temp[property] = obj[property] === '' ? null : obj[property];
  }

  return temp;
}
